"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyPredictor = void 0;

function decodeRowAcc(row, stride) {
  var length = row.length - stride;
  var offset = 0;

  do {
    for (var i = stride; i > 0; i--) {
      row[offset + stride] += row[offset];
      offset++;
    }

    length -= stride;
  } while (length > 0);
}

function decodeRowFloatingPoint(row, stride, bytesPerSample) {
  var index = 0;
  var count = row.length;
  var wc = count / bytesPerSample;

  while (count > stride) {
    for (var i = stride; i > 0; --i) {
      row[index + stride] += row[index];
      ++index;
    }

    count -= stride;
  }

  var copy = row.slice();

  for (var _i = 0; _i < wc; ++_i) {
    for (var b = 0; b < bytesPerSample; ++b) {
      row[bytesPerSample * _i + b] = copy[(bytesPerSample - b - 1) * wc + _i];
    }
  }
}

function applyPredictor(block, predictor, width, height, bitsPerSample, planarConfiguration) {
  if (!predictor || predictor === 1) {
    return block;
  }

  for (var i = 0; i < bitsPerSample.length; ++i) {
    if (bitsPerSample[i] % 8 !== 0) {
      throw new Error('When decoding with predictor, only multiple of 8 bits are supported.');
    }

    if (bitsPerSample[i] !== bitsPerSample[0]) {
      throw new Error('When decoding with predictor, all samples must have the same size.');
    }
  }

  var bytesPerSample = bitsPerSample[0] / 8;
  var stride = planarConfiguration === 2 ? 1 : bitsPerSample.length;

  for (var _i2 = 0; _i2 < height; ++_i2) {
    // Last strip will be truncated if height % stripHeight != 0
    if (_i2 * stride * width * bytesPerSample >= block.byteLength) {
      break;
    }

    var row = void 0;

    if (predictor === 2) {
      // horizontal prediction
      switch (bitsPerSample[0]) {
        case 8:
          row = new Uint8Array(block, _i2 * stride * width * bytesPerSample, stride * width * bytesPerSample);
          break;

        case 16:
          row = new Uint16Array(block, _i2 * stride * width * bytesPerSample, stride * width * bytesPerSample / 2);
          break;

        case 32:
          row = new Uint32Array(block, _i2 * stride * width * bytesPerSample, stride * width * bytesPerSample / 4);
          break;

        default:
          throw new Error("Predictor 2 not allowed with ".concat(bitsPerSample[0], " bits per sample."));
      }

      decodeRowAcc(row, stride, bytesPerSample);
    } else if (predictor === 3) {
      // horizontal floating point
      row = new Uint8Array(block, _i2 * stride * width * bytesPerSample, stride * width * bytesPerSample);
      decodeRowFloatingPoint(row, stride, bytesPerSample);
    }
  }

  return block;
}

exports.applyPredictor = applyPredictor;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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